import {
  FilterAlignStatusReturnType,
  SwingContractAligneStatus,
  SwingContractAligneStatusIndex,
  SwingContractStatusObject,
} from '../types/FieldNomsSwingContract.type';

function createStatusObject<T extends Record<string, string>>(
  statusObject: T,
  classNames: Record<string, string>
): Record<string, SwingContractStatusObject> {
  return Object.keys(statusObject).reduce(
    (acc, key) => {
      const enumKey = statusObject[key as keyof T];
      acc[enumKey] = {
        title: enumKey,
        className: classNames[enumKey],
      };
      return acc;
    },
    {} as Record<string, SwingContractStatusObject>
  );
}

const AligneStatusClassNames = {
  [SwingContractAligneStatus.NEW]: 'not_requested',
  [SwingContractAligneStatus.SUBMITTED]: 'submitted',
  [SwingContractAligneStatus.SUCCESS]: 'success',
  [SwingContractAligneStatus.FAILURE]: 'failure',
};

export const ALIGNE_STATUS = createStatusObject(
  SwingContractAligneStatus,
  AligneStatusClassNames
);

export const ALIGNE_ACTIONS = [
  SwingContractAligneStatus.SUCCESS,
  SwingContractAligneStatus.SUBMITTED,
];

export const ALIGNE_ACTIONS_FOR_LATEST = [SwingContractAligneStatus.SUCCESS];

export const FilterAligneStatusOptions = (
  isActive: boolean
): FilterAlignStatusReturnType[] => {
  return Object.keys(SwingContractAligneStatus).map((key) => {
    const id =
      SwingContractAligneStatusIndex[
        key as keyof SwingContractAligneStatusIndex
      ];
    const name =
      SwingContractAligneStatus[key as keyof SwingContractAligneStatus];
    return {
      id,
      name,
      isActive: [SwingContractAligneStatus.SUCCESS].includes(name)
        ? isActive
        : true,
    } as FilterAlignStatusReturnType;
  });
};

export const ActionableAlignStatusId = [
  SwingContractAligneStatusIndex.NEW,
  SwingContractAligneStatusIndex.SUBMITTED,
  SwingContractAligneStatusIndex.FAILURE,
];

export const LatestAlignStatusId = [
  SwingContractAligneStatusIndex.NEW,
  SwingContractAligneStatusIndex.SUBMITTED,
  SwingContractAligneStatusIndex.SUCCESS,
  SwingContractAligneStatusIndex.FAILURE,
];
